export const SET_FILTER = "SET_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";
